module.exports = __webpack_public_path__ + "static/media/habbit-wireframe.ef8d6878.png";